import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

export default function <T>(
  url: string,
  initialState: T,
  params?: any,
  fetchOnMount: boolean = true
): [T, boolean, () => void] {
  const [data, setData] = useState<T>(initialState);
  const [loading, setLoading] = useState(true);
  const fetchUrl = useCallback(async () => {
    try {
      const response = await axios.get<T>(url, {
        params,
      });
      const json = response.data;
      setData(json);
      setLoading(false);
    } catch {
      toast.error('Ocorreu um erro ao encontrar um resultado.');
      setLoading(false);
    }
  }, [url, params]);

  useEffect(() => {
    if (fetchOnMount) {
      fetchUrl();
    } else {
      setLoading(false);
      return;
    }
  }, [fetchUrl]);
  return [data, loading, fetchUrl];
}
